import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["type", "value"]
const _hoisted_3 = ["aria-label"]

import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue'


export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'PasswordInput',
  props: {
  modelValue: { type: String, default: '' }
},
  emits: ['update:modelValue'],
  setup(__props) {






const revealed = ref(false)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      type: revealed.value ? 'text' : 'password',
      value: __props.modelValue,
      class: "placeholder-gray-400 block pl-3 pr-11 py-3.5 rounded-lg w-full focus:border-gray-800 border-2 border-gray-200 focus:ring-0 appearance-none transition duration-150 ease-in-out text-sm leading-5 focus:outline-none font-semibold tracking-wide",
      onInput: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:modelValue', $event.target.value)))
    }), null, 16, _hoisted_2),
    _createElementVNode("button", {
      type: "button",
      tabindex: "-1",
      "aria-label": revealed.value ? 'Hide password' : 'Show password',
      class: "absolute inset-y-0 right-0 flex items-center pr-3",
      onClick: _cache[1] || (_cache[1] = $event => (revealed.value = !revealed.value))
    }, [
      (revealed.value)
        ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
            key: 0,
            class: "h-5 w-5 text-gray-800"
          }))
        : (_openBlock(), _createBlock(_unref(EyeIcon), {
            key: 1,
            class: "h-5 w-5 text-gray-400"
          }))
    ], 8, _hoisted_3)
  ]))
}
}

})